export const blue = '#1890ff';
export const green = '#52c41a';
export const red = '#f5222d';
export const gold = '#faad14';
